import { LayerType } from "../constant/LayerType";
import LayerAdminService from "./LayerAdminService";

export default class OSCodePointsService extends LayerAdminService {
    public async Revert(): Promise<any> {
        return this._client
          .delete<any>(`${this._endpoint}/${LayerType.OS_CODE_POINTS}/latest`)
          .then((response) => {
            return response.data;
          });
      }
}